export default "__VITE_ASSET__a4ba74bf__"